import Link from "next/link";
import Image from "next/image";
import logoTenup from "@/assets/images/logos/logo-tenup.png";

export type PrimaryButtonProps = {
  text?: string;
  navigateTo?: string;
  className?: string;
  variant?: "default" | "tenup" | "tenup-mobile";
  target?: string;
  onClick?: () => void;
  disabled?: boolean; // nouvelle prop
};

export const PrimaryButton = ({
  text,
  navigateTo,
  className = "",
  variant = "default",
  target = "_self",
  onClick,
  disabled = false,
}: PrimaryButtonProps) => {
  const isTenupVariant = variant === "tenup" || variant === "tenup-mobile";
  const tenupUrl = "https://tenup.fft.fr/club/56600078";
  const effectiveNavigateTo = isTenupVariant ? tenupUrl : navigateTo;
  const effectiveTarget = isTenupVariant ? "_blank" : target;

  const baseClasses =
    "flex items-center justify-center bg-tertiary text-primary text-sm lg:text-base uppercase px-2 lg:px-6 py-2 lg:py-4 border border-tertiary transition-all duration-300 w-fit";

  const enabledClasses =
    "hover:bg-[#F29545] hover:border-transparent hover:shadow-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-primary";

  const disabledClasses = "opacity-50 cursor-not-allowed";

  const buttonClasses = `${baseClasses} ${
    disabled ? disabledClasses : enabledClasses
  } ${className}`;

  const content =
    variant === "tenup" || variant === "tenup-mobile" ? (
      <Image
        src={logoTenup}
        alt="Ten'Up"
        className={
          variant === "tenup-mobile" ? "h-24 w-auto" : "h-[10px] xl:h-12 w-auto"
        }
      />
    ) : (
      text
    );

  if (effectiveNavigateTo && !disabled) {
    return (
      <Link
        href={effectiveNavigateTo}
        className={buttonClasses}
        target={effectiveTarget}
        rel={effectiveTarget === "_blank" ? "noopener noreferrer" : undefined}
        aria-label={
          variant === "tenup" || variant === "tenup-mobile" ? text : undefined
        }
        onClick={onClick}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      className={buttonClasses}
      aria-label={
        variant === "tenup" || variant === "tenup-mobile" ? text : undefined
      }
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      {content}
    </button>
  );
};
